import React, {useState, useEffect} from "react";
import BackButton from "components/Button/BackButton";
import SaveButton from "components/Button/SaveButton";
import { useNavigate } from "react-router-dom";
import { FormTypeAdd, FormTypeEdit } from "utils/Constant";
import { removeNonNumeric } from "utils/helpers";
import { useModal } from "context/ModalContext";
import ImageIcon from "assets/icon/ImageIcon";
import { FormCard, MainBodyCard, PagesFormTitle } from "components/Cards";
import NoImage from "assets/images/no-image.png"
import { CustomerService } from "services/CustomerService/CustomerService";

export default function CustomerForm(){
    let navigate = useNavigate()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()
    const { fetchCustomerById, fetchCreateCustomer, fetchUpdateCustomer} = CustomerService()
    
    let queryString = new URLSearchParams(window.location.search)
    let formType = queryString.get("formType")
    let customerId = queryString.get("customerId")
    
    const [customerName, setCustomerName] = useState('')
    const [idNumber, setIdNumber] = useState('')
    const [address, setAddress] = useState('-')
    const [phone, setPhone] = useState('')
    const [email, setEmail] = useState('-')
    const [instagram, setInstagram] = useState('-')
    const [idPhotoFile, setIdPhotoFile] = useState('')
    const [idPhotoFileUrl, setIdPhotoFileUrl] = useState('')
    
    const [status, setStatus] = useState('')
    const [createBy, setCreateBy] = useState('')
    const [createDate, setCreateDate] = useState('')
    const [updateBy, setUpdateBy] = useState('')
    const [updateDate, setUpdateDate] = useState('')

    // Event
    const handleIdPhotoChange = (e) => {
        setIdPhotoFile((e.target.files[0]));
        if (e.target.files[0] != null) {
            setIdPhotoFileUrl(URL.createObjectURL(e.target.files[0]));
        }
    }
    
    // Button Event
    const saveBtnClick = async () => {
        if(!validation()) return

        const onConfirm = confirm()
        if (!onConfirm) return

        showLoading()

        try {
            if (formType === FormTypeAdd) {
                const res = await fetchCreateCustomer(
                    customerName,
                    idNumber, 
                    address,
                    phone,
                    email,
                    instagram,
                    idPhotoFile
                )
                if (!res) return
            } else {
                const res = await fetchUpdateCustomer(
                    customerId,
                    customerName,
                    idNumber, 
                    address,
                    phone,
                    email,
                    instagram,
                    idPhotoFile
                )
                if (!res) return
            }

            showSuccess({
                onSuccess: () => {
                    navigate("/customer")
                }
            })
        }
        finally {
            hideLoading()
        }
    }
    const backBtnClick = () => {
        navigate(-1)
    }

    // Function
    const validation = () => {        
        if (customerName === null){
            showFail('Customer Name is required!')
            return false
        }
        if (idNumber === '') {
            showFail('Id Number is required!')
            return false
        }
        if (address === '') {
            showFail('Address is required!')
            return false
        }
        if (email === '') {
            showFail('Email is required!')
            return false
        }
        if (phone === '') {
            showFail('Phone is required!')
            return false
        }
        if (instagram === '') {
            showFail('Instagram is required!')
            return false
        }

        return true
    }
    
    useEffect(() => {
        const onLoad = async () => {
            // If Form Type Edit then get data
            if (formType === FormTypeEdit) {
                showLoading()

                try {
                    const res = await fetchCustomerById(customerId)
                    if (!res) return 

                    let data = res.data

                    setCustomerName(data.customerName)
                    setIdNumber(data.idNumber)
                    setAddress(data.address)
                    setPhone(data.phone)
                    setEmail(data.email)
                    setInstagram(data.instagram)
                    setIdPhotoFileUrl(data.idPhotoUrl)

                    // Header
                    setStatus(data.status)
                    setCreateBy(data.createBy)
                    setCreateDate(data.createDate)
                    setUpdateBy(data.updateBy)
                    setUpdateDate(data.updateDate)
                }
                finally {
                    hideLoading()
                }
            }
        }

        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <div>
                <PagesFormTitle 
                    title='Detail Pelanggan'
                    formType={formType}
                    status={status}
                    createDate={createDate}
                    updateDate={updateDate}
                    updateBy={updateBy}
                />
                

                <div className="mt-5 flex flex-col gap-3 ">
                    {/* Photo ID */}
                    <FormCard title='Foto ID'>
                        <img
                            className="w-auto h-[200px] object-cover mx-auto border rounded-md"
                            src={idPhotoFileUrl === null || idPhotoFileUrl === '' ? NoImage : idPhotoFileUrl}
                            alt="ID"
                        />
                        <input className="hidden" id="idPhoto" type="file" accept=".jpg, .png, .jpeg, .gif|image/*" onChange={handleIdPhotoChange} />
                        <button onClick={() => document.getElementById('idPhoto').click()} 
                            className="mt-2 px-3 py-2 bg-app-matte-black text-white rounded-md text-center cursor-pointer w-full flex gap-2 justify-center items-center"
                        >
                            <ImageIcon />
                            Add Image
                        </button>
                    </FormCard>

                    {/* Customer Name */}
                    <FormCard title='Nama Pelanggan'>
                        <input className="input" value={customerName} onChange={(e) => { setCustomerName(e.target.value) }} maxLength={40} />
                    </FormCard>

                    {/* Id Number */}
                    <FormCard title='No KTP'>
                        <input className="input" value={idNumber} onChange={(e) => { setIdNumber(removeNonNumeric(e.target.value)) }} maxLength={16} />
                    </FormCard>
                    
                    {/* Address */}
                    <FormCard title='Alamat'>
                        <input className="input" value={address} onChange={(e) => { setAddress(e.target.value) }} maxLength={40} />
                    </FormCard>

                    {/* Email */}
                    <FormCard title='Email'>
                        <input className="input" value={email} onChange={(e) => { setEmail(e.target.value) }} maxLength={40} />
                    </FormCard>

                    {/* Phone */}
                    <FormCard title='No. Telepon / HP'>
                        <input className="input" value={phone} onChange={(e) => { setPhone(removeNonNumeric(e.target.value)) }} maxLength={16} />
                    </FormCard>

                    {/* Instagram */}
                    <FormCard title='Instagram'>
                        <input className="input" value={instagram} onChange={(e) => { setInstagram(e.target.value) }} maxLength={40} />
                    </FormCard>
                </div>
            </div>            

            {/* Button */}
            <div className="mt-5 flex flex-wrap justify-end gap-2">
                <SaveButton onClick={saveBtnClick} visible={true} />
                <BackButton onClick={backBtnClick} />
            </div>
        </MainBodyCard>
        
    )
}

const CardForm = ({ title, children}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="w-48">
                <span>{title}</span>
            </div>
            <div className="px-4 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}